module.exports = __webpack_public_path__ + "static/img/produto_g.f693a50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/tubaina-zero/produto_g.png
// module id = FG6Z
// module chunks = 0